import { type BEResponsePagedResponseNotificaResponseDTO } from '@framework/api-client/api/backoffice/schemas/bEResponsePagedResponseNotificaResponseDTO.ts';
import { type BEResponsePagedResponseNotificaUtenteResponseDTO } from '@framework/api-client/api/inquiries-compile/schemas/bEResponsePagedResponseNotificaUtenteResponseDTO.ts';
import dayjs from 'dayjs';
import produce from 'immer';
import { useQueryClient } from 'react-query';
import { useNotificationsContext } from '../context/NotificationsContext.tsx';

export function useSetAllReadNotifications() {
  const { useMarkAllAsRead, getGetNotificationsQueryKey } =
    useNotificationsContext();

  const NotificationsApiKey = getGetNotificationsQueryKey()[0] as string; // "/notifiche"

  const queryClient = useQueryClient();
  const mutationOptions = {
    mutation: {
      onMutate: () => {
        queryClient.cancelQueries(NotificationsApiKey);

        // https://github.com/TanStack/query/issues/599#issuecomment-647586208
        const notificationQueriesData = queryClient.getQueriesData<
          | BEResponsePagedResponseNotificaResponseDTO
          | BEResponsePagedResponseNotificaUtenteResponseDTO
        >(NotificationsApiKey);
        for (const [key] of notificationQueriesData) {
          queryClient.setQueryData<
            | BEResponsePagedResponseNotificaResponseDTO
            | BEResponsePagedResponseNotificaUtenteResponseDTO
          >(key, response => setAllNotificationAsRead(response));
        }
      },
      onError: (context: any) => {
        // In caso ci sia stato un errore, prima ripristiniamo le notifiche
        // di quello eliminato..
        queryClient.setQueryData(context.key, context.previousData);
        // ..e dopo ricarichiamo dal backend
        queryClient.invalidateQueries(NotificationsApiKey);
      },
    },
  };
  if (!useMarkAllAsRead) return null;
  // biome-ignore lint/correctness/useHookAtTopLevel: Sappiamo che è istanziato
  return useMarkAllAsRead(mutationOptions);
}

function setAllNotificationAsRead(
  response:
    | BEResponsePagedResponseNotificaResponseDTO
    | BEResponsePagedResponseNotificaUtenteResponseDTO
    | undefined,
) {
  return produce(response ?? {}, draft => {
    // Controlla se la lista di notifiche esiste
    if (draft?.data?.list) {
      // Itera su ogni notifica
      for (const notification of draft.data.list) {
        // Imposta la data di presa visione solo se non è già presente
        if (!notification.dataPresaVisione) {
          notification.dataPresaVisione = dayjs().toDate().toString();
        }
      }
    }
    return draft;
  });
}
